function formatTanggal(tanggal) {
  const date = new Date(tanggal);

  // Format options
  const options = { day: "2-digit", month: "short", year: "2-digit" };

  // Format the date to "01-Dec-24"
  const formattedDate = date
    .toLocaleDateString("en-GB", options)
    .replace(",", "") // Remove comma
    .replace(/\s/g, "-"); // Replace spaces with hyphens

  return formattedDate;
}

export default formatTanggal;
